import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import AdminRolesForm from '../AdminRolesForm';

import { closeAdminRolesModal } from '../../../actions/siteadmin/modalActions';

import s from './AdminRolesModal.css';
import messages from '../../../locale/jsonMessages';
class AdminRolesModal extends Component {

  render() {
    const { closeAdminRolesModal, adminRolesModal, paginationData, id, adminRolesModalData } = this.props;

    return (
      <Modal show={adminRolesModal} onHide={closeAdminRolesModal} dialogClassName='commonModalContainer globalModalContainer'>
        <Modal.Header closeButton className='commonModalHeader'>
          <Modal.Title className='commonModalTitle'>
            {id ? <FormattedMessage  {...messages.editAdminRoleLabel} /> : <FormattedMessage  {...messages.addAdminRoleLabel} />}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          <AdminRolesForm paginationData={paginationData} initialValues={adminRolesModalData} />
        </Modal.Body>
      </Modal>
    )
  }
}

const selector = formValueSelector('AdminRolesForm');

const mapState = (state) => ({
  adminRolesModal: state.adminModalStatus.adminRolesModal,
  id: selector(state, 'id'),
  adminRolesModalData: state.adminModalStatus.adminRolesModalData
});

const mapDispatch = {
  closeAdminRolesModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(AdminRolesModal)));
